/* eslint-disable */
/**
 * The path of the `AdminPage` to be consumed by a `<Router />`
 * @export
 */
export const ADMIN_PAGE_PATH = `/admin`;

/**
 * Create a `href` that will resolve to `AdminPage`
 * @export
 * @returns {string} The `ADMIN_PAGE_PATH`
 */
export const createAdminPageLink = () => ADMIN_PAGE_PATH;

/**
 * Determine if the current page is the `AdminPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `AdminPage`
 */
export const isAdminPage = (match) => match.path === ADMIN_PAGE_PATH;
